const _require = require('@truqc/content-path'),
  setContentValue = _require.setContentValue;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
  * @function evalute - evaluate setTransientContextBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const path = await evaluateSource(source.path, content, parentContentPath, transientContext, nativeFunctions);
  if (typeof path !== 'string') {
    return undefined;
  }
  const value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  const childTransientContext = setContentValue(path, transientContext, value);
  return evaluateSource(source.behavior, content, parentContentPath, childTransientContext, nativeFunctions);
};
module.exports = {
  evaluate
};